import  * as api from  '@/api/kzActivity/show'
import * as TYPES from './type';

export default {
  // 课中活动课堂表现
  async getShowList({ commit, state }, { paramets, cb }) {
    const result = await api.reqShowList(paramets)
    commit(TYPES.SHOW_LIST, { result })
    cb && cb()
  },
  async getShowStuById({ commit, state }, { paramets, cb }) {
    const result = await api.reqShowStuById(paramets)
    commit(TYPES.SHOW_INFO, { result, type: 'stu' })
    cb && cb()
  },
  async getShowStuDetail({ commit, state }, { paramets, cb }) {
    const result = await api.reqShowStuDetail(paramets)
    commit(TYPES.SHOW_INFO, { result, type: 'detail' })
    cb && cb()
  },
  async delShowDelById({ commit, state }, { paramets, cb }) {
    const result = await api.reqShowDelById(paramets)
    commit(TYPES.SHOW_INFO, { result, type: 'del' })
    cb && cb()
  },
}